import { carePhaseDefs } from '@shared';
import type { CareScenarioSummary } from '@shared/consumerPlan';
import { CARE_ENVIRONMENT_LABELS } from '../lib/copy';
import { approxMoney } from '../lib/format';
import { DetailList } from './figures';

export function CareCostBreakdown({ scenario }: { scenario: CareScenarioSummary }) {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-muted-foreground text-sm">
        Costs rise {scenario.inflationPercent.toFixed(1)}% a year until care starts at {scenario.careStartAge}.
        Insurance premiums are separate.
      </p>
      {scenario.phases.map(phase => (
        <div key={phase.carePhase} className="flex flex-col gap-2">
          <h2 className="font-semibold text-gray-950">{carePhaseDefs[phase.carePhase].label}</h2>
          <DetailList
            rows={[
              { label: 'Where', value: CARE_ENVIRONMENT_LABELS[phase.careEnvironment] },
              { label: 'How long', value: `${Math.round(phase.months)} months` },
              ...(phase.inHome
                ? [{ label: 'Family time', value: `${phase.familyHoursPerWeek.toFixed(1)} hours a week` }]
                : []),
              { label: 'Projected cost for this stage', value: approxMoney(phase.cost) },
            ]}
          />
        </div>
      ))}
      <DetailList rows={[{ label: 'All stages together', value: approxMoney(scenario.totalCost) }]} />
    </div>
  );
}
